import { BannerCard } from '@/components/sidebar/BannerCard';
import { useBanner } from '@/hooks/useBanner';

/**
 * Data wrapper for the sidebar banner. Always mounted in `AppSidebar`; renders
 * `<BannerCard/>` when a banner is set and nothing otherwise (incl. initial
 * load, to avoid a flash). Reads from `/api/status` via `useBanner`.
 */
export function SidebarBanner() {
  const { banner, isInitialLoad } = useBanner();
  if (isInitialLoad || banner === null) return null;
  return (
    <div className="px-2 pb-1">
      <BannerCard title={banner.title} description={banner.description} color={banner.color} />
    </div>
  );
}
